const getters = {
  WORKBENCH_functionList: state => state.WORKBENCH.functionList
}

export default getters
